
<div>
  <EntityShowHeader :entity="entity" />

  <DataTable
    ref="activitiesTable"
    :columns="columns"
    :fetch-callback="fetchEntityActivities"
    :model="ActivityModel"
    has-row-actions
  >
    <template #tableHeaderActions>
      <b-button
        v-can:activities.create
        variant="primary"
        size="sm"
        @click="openCreateActivityModal"
      >
        <Icon icon="plus-circle" size="14" class="mr-2"/>
        {{ __('activities.button-add-activity') }}
      </b-button>
    </template>

    <template #actionButtons="{ item }">
      <ActionPopover :id="item.id" v-can-any="[ 'activities.update', 'activities.destroy' ]">
        <b-button
          v-can:activities.update
          class="dropdown-item"
          size="sm"
          @click="openEditActivityModal(item.id)"
        >
          <Icon icon="edit" class="mr-2" size="14"/>
          {{ __('buttons.edit') }}
        </b-button>

        <b-button
          v-can:activities.destroy
          class="dropdown-item"
          size="sm"
          @click="remove(item.id)"
        >
          <Icon icon="trash" class="mr-2" size="14"/>
          {{ __('buttons.remove') }}
        </b-button>
      </ActionPopover>
    </template>

    <template #type="{ item }">
      <Badge variant="soft-primary">
        <Icon :icon="item.typeData().icon" size="12" class="mr-2"/>
        {{ item.typeData().label }}
      </Badge>
    </template>

    <template #subject="{ item }">
      <a href="#" @click.prevent="openPreviewActivityModal(item.id)">
        {{ item.subject }}
      </a>
    </template>

    <template #status="{ item }">
      <Badge :variant="item.statusData().badge">
        {{ item.statusData().label }}
      </Badge>
    </template>
  </DataTable>
</div>
